import { create } from "zustand";

interface DraftState {
  drafts: Record<string, any>;

  saveOrUpdateDraft: (
    platform: string,
    data: any
  ) => void;

  removeDraft: (platform: string) => void;

  clearDrafts: () => void;
}

export const useDraftStoreZustand = create<DraftState>((set) => ({
  drafts: {},

  saveOrUpdateDraft: (platform, data) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [platform]: {
          ...state.drafts[platform],
          ...data,
          platform,
          updatedAt: Date.now(),
        },
      },
    })),

  removeDraft: (platform) =>
    set((state) => {
      const updated = { ...state.drafts };
      delete updated[platform];
      return { drafts: updated };
    }),

  clearDrafts: () => set({ drafts: {} }),
}));